import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { initializeFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC-puC2RBdh9wb4BhLFefbRa8mmnSrNz50",
  authDomain: "recertagent.firebaseapp.com",
  projectId: "recertagent",
  storageBucket: "recertagent.firebasestorage.app",
  messagingSenderId: "940435651385",
  appId: "1:940435651385:web:0f20994121d101d6bec6e8"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);
// Long polling instead of Firestore's default streaming connection. Safari can
// accept the stream and then stall (iCloud Private Relay, content blockers),
// which holds every read for up to a minute before Firestore falls back.
export const db = initializeFirestore(app, { experimentalForceLongPolling: true });
export { app };
export default app;